// extracted by mini-css-extract-plugin
module.exports = {"content":"page-rich-text-section-module--content--3JtT3"};